// Meta Pixel utility functions
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return

  // Check if fbq is already initialized
  if (window.fbq) return

  // Meta Pixel initialization code
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  let n = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v

  const s = b.getElementsByTagName(e)[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    // Fallback: append to head if no script tags exist
    b.head.appendChild(t)
  }

  // Initialize with your Pixel ID
  window.fbq('init', '1214319980911777')

  // Track PageView
  window.fbq('track', 'PageView')

  // Add noscript fallback image
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1214319980911777&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  console.log('Meta Pixel initialized successfully')
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
    console.log('Meta Pixel: AddToCart event tracked')
  } else {
    console.warn('Meta Pixel: fbq not available, AddToCart event not tracked')
  }
}
